import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

export const get = async (params) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/integration',
    params
  })

  return response?.data
}

export const accurateConnect = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/integration/accurate/connect',
    data
  })

  return response?.data
}

export const accurateDisconnect = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: '/integration/accurate/disconnect'
  })

  return response?.data
}

export const accurateBusinessData = async () => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: '/integration/accurate/business-data'
  })

  return response?.data
}

export const accurateBusinessDataConnect = async (data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: '/integration/accurate/business-data/connect',
    data
  })

  return response?.data
}
